/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
import TableComponent from "../../components/TableComponent";
import { GridColDef } from "@mui/x-data-grid";
import { useState } from "react";
import RejectReasonModal from "../../Modals/rejectReason";
import CommissionOfferModal from "../../Modals/commissionOffer";
import ViewMessageModal from "../../Modals/viewMessageModal";
import { formatDubaiDateTime } from "../../utils/dateTime";
import { useNavigate } from "react-router-dom";

const NotificationsList = ({ data }: { data: any }) => {
  const navigate = useNavigate();
  const [message, setMessage] = useState("");

  const columns: GridColDef[] = [
    {
      flex: 1,
      minWidth: 150,
      field: "title",
      headerName: "Title",
      editable: false,
      sortable: false,
      renderCell: ({ row }: any) => {
        return (
          <div className="user_block click_action">
            <p>
              <b>{row?.broadCastTitle || "-"}</b>
            </p>
          </div>
        );
      },
    },

    {
      flex: 1,
      minWidth: 100,
      field: "from",
      headerName: "Sent From",
      editable: false,
      sortable: false,
      renderCell: ({ row }: any) => {
        return (
          <div className="user_block click_action">
            <p>
              <b>{"Admin"}</b>
            </p>
          </div>
        );
      },
    },
    {
      flex: 2,
      minWidth: 200,
      field: "message",
      headerName: "Message",
      editable: false,
      sortable: false,
      renderCell: ({ row }: any) => {
        return (
          <div
            className="user_block click_action"
            onClick={() => {
              if (row?.broadCastType === "email") {
                setMessage(row?.broadCastMessage);
                setMessageModal(true);
              }
            }}
          >
            <p>
              <b>
                {row?.broadCastType === "email" ? (
                  <div
                    dangerouslySetInnerHTML={{
                      __html: row?.broadCastMessage
                        ? row.broadCastMessage?.substring(0, 30) + "..."
                        : "",
                    }}
                  />
                ) : (
                  row?.broadCastMessage || "-"
                )}
              </b>
            </p>
          </div>
        );
      },
    },
    {
      flex: 1,
      minWidth: 150,
      field: "type",
      headerName: "Type",
      editable: false,
      sortable: false,
      renderCell: ({ row }: any) => {
        return (
          <div className="user_block click_action">
            <p>
              <b>{row?.broadCastType || "-"}</b>
            </p>
          </div>
        );
      },
    },
    {
      flex: 1,
      minWidth: 150,
      field: "sendTo",
      headerName: "Send To",
      editable: false,
      sortable: false,
      renderCell: ({ row }: any) => {
        return (
          <div
            role="button"
            tabIndex={0}
            className="user_block click_action"
            onClick={() =>
              navigate(`/manage-notifications/view-users/${row?.id}`, {
                state: { type: row?.broadCastTo },
              })
            }
          >
            <p>
              <b>{row?.broadCastTo || "-"}</b>
            </p>
          </div>
        );
      },
    },
    {
      minWidth: 250,
      field: "date",
      headerName: "Created Date",
      editable: false,
      sortable: false,
      renderCell: ({ row }: any) => {
        return (
          <div className="user_block click_action">
            <p>
              <b>
                {row?.createDate ? formatDubaiDateTime(row?.createDate) : "-"}
              </b>
            </p>
          </div>
        );
      },
    },
  ];
  let hidden = ["fullName"];

  const [open, setOpen] = useState(false);
  const handleCloseModal = () => {
    setOpen(false);
  };

  const [open1, setOpen1] = useState(false);
  const handleCloseModal1 = () => {
    setOpen1(false);
  };
  const [reason, setReason] = useState("");
  const [messageModal, setMessageModal] = useState(false);

  return (
    <>
      <div className="sorting_table">
        <TableComponent
          columns={columns?.filter((item) => !hidden.includes(item.field))}
          rows={data}
        />
      </div>

      <CommissionOfferModal
        open={open}
        onClose={handleCloseModal}
        setOpen={setOpen}
      />

      <ViewMessageModal
        open={messageModal}
        setOpen={setMessageModal}
        message={message}
      />

      <RejectReasonModal
        open={open1}
        onClose={handleCloseModal1}
        setOpen={setOpen1}
        onClick={() => setOpen1(false)}
        setReason={setReason}
        reason={reason}
      />
    </>
  );
};

export default NotificationsList;
